import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const TOTAL_SECONDS = 17 * 60 + 34;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
type CountdownProps = {
  tone?: 'light' | 'dark';
};
export function Countdown({
  tone = 'light'
}: CountdownProps) {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const cells = [{
    value: pad(hours),
    label: 'HOURS'
  }, {
    value: pad(minutes),
    label: 'MIN'
  }, {
    value: pad(seconds),
    label: 'SEC'
  }];
  const isDark = tone === 'dark';
  return <div className="flex w-full flex-col items-center" data-id="element-19" data-mp="15bof7zu4u4gb">
      <p className={['flex items-center gap-2 text-[11px] font-extrabold uppercase tracking-[0.14em] sm:text-xs', isDark ? 'text-sky-400' : 'text-navy-800'].join(' ')} data-id="element-20" data-mp="1592984mw3x07">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-21" data-mp="17qzts3atu6r9" />
        The special launch offer ends in:
      </p>
      <div className="mt-3 flex items-stretch justify-center gap-2 sm:gap-3" data-id="element-22" data-mp="12rd77393ze5s">
        {cells.map((cell, index) => <React.Fragment key={cell.label} data-id="element-23" data-mp="f3di07rg3vtb" data-mpi={index}>
            <div className={['flex min-w-[68px] flex-col items-center rounded-xl px-3 py-2 sm:min-w-[84px] sm:px-4 sm:py-3', isDark ? 'bg-white/10 ring-1 ring-white/15' : 'bg-navy-900'].join(' ')} data-id="element-24" data-mp="f4ew6l3rcyf9">
              <span className="font-display text-3xl font-bold tabular-nums text-white sm:text-4xl" data-id="element-25" data-mp="jzu651ynaa6e">
                {cell.value}
              </span>
              <span className="mt-0.5 text-[10px] font-bold uppercase tracking-[0.12em] text-sky-400" data-id="element-26" data-mp="1vgu70lz25xc1">
                {cell.label}
              </span>
            </div>
            {index < cells.length - 1 ? <span className={['self-center font-display text-2xl font-bold', isDark ? 'text-white/40' : 'text-navy-900/40'].join(' ')} aria-hidden="true" data-id="element-27" data-mp="x482goo8tpua">
                :
              </span> : null}
          </React.Fragment>)}
      </div>
      <p className={['mt-3 text-center text-xs font-medium sm:text-[13px]', isDark ? 'text-white/60' : 'text-navy-800/60'].join(' ')} data-id="element-28" data-mp="9dc75hkkwcia">
        Launch pricing available for a limited time.
      </p>
    </div>;
}